const e = "_menuDrawer_18mzh_1", t = "_fullWidth_18mzh_11", l = {
  menuDrawer: e,
  fullWidth: t
};
export {
  l as default,
  t as fullWidth,
  e as menuDrawer
};
//# sourceMappingURL=MenuDrawer.module.css.js.map
